export enum ScreenWidth {
  Mobile = "MOBILE",
  Small = "SMALL",
  Medium = "MEDIUM",
  Large = "LARGE",
  XLarge = "XLARGE",
  Wide = "WIDE",
}
